import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export default function PrivateRoute({ featureCode, children }) {
  const user = useSelector(state => state.user);
  const location = useLocation();
  const isAuthenticated = user?.token || localStorage.getItem('token');
  const features = user?.features || [];
  const onboarding = user?.onboarding;
  const isOnboardingPage = location.pathname === '/onboarding';
  const isSupportTicketPage = location.pathname === '/support' || location.pathname.startsWith('/support/');

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Allow access to onboarding page if user is in onboarding process
  if (isOnboardingPage) {
    return children;
  }

  // Allow access to support ticket pages even if onboarding not complete
  if (isSupportTicketPage) {
    return children;
  }

  // Block access to main app if onboarding not complete
  // NEW API FORMAT: stage is 'pending', 'draft', or 'completed'
  if (onboarding && onboarding.stage && onboarding.stage !== 'completed') {
    return <Navigate to="/onboarding" replace />;
  }

  if (!featureCode) {
    return children;
  }
  
  // Core features that are always accessible, regardless of the user's plan.
  // Keep this in sync with the override list in Navbar.js so the sidebar button
  // and the route guard agree — otherwise the button renders as clickable but
  // PrivateRoute bounces the user to /profile.
  const ALWAYS_ACCESSIBLE = ['EDIT_ONBOARDING_FORM', 'SSU_BASIC', 'SUPPORT_TICKETS', 'SUSPIRE_CIRCLE'];
  const hasAccess = ALWAYS_ACCESSIBLE.includes(featureCode) || features.some(f => f.code === featureCode);
  return hasAccess ? children : <Navigate to="/profile" replace />;
}
